<template>
  <div id="componentFormPreview">
    <!-- <BlockUI :blocked="blockedDocument" :fullScreen="true">
      <ProgressSpinner v-if="blockedDocument" />
    </BlockUI> -->
    <div v-if="blockedDocument">
      <LoadingArete />
    </div>
    <Toolbar style="padding: 3px 0px !important;">
      <template #left>
        <Button
          v-if="$route.params.formid != null"
          label=""
          icon="pi pi-arrow-left"
          class="p-button-link p-mr-2"
          @click="backto()"
        />
        <div class="p-mt-2" v-if="selectedform">
          <span class="p-mt-2">
            <label class="formlabel p-mr-1"
              ><h5>{{ selectedform.name }}</h5></label
            >
            <label v-if="loadedForm.applicationName != null"
              class="formlabel p-mr-1"
              style="font-weight: 700; color: darkgray; font-size: 15px"
            >
              [{{ loadedForm.applicationName }}]</label
            >
          </span>
          <span class="p-mr-1 p-mr-6"
            ><i
              class="pi pi-info-circle p-mr-2"
              style="font-size: 15px"
              v-tooltip.bottom="selectedform.description"
            ></i
          ></span>

           <span :class="'customstatus published '">
                  <label class="formlabel">Form Status :</label>
                  published
                </span>
                <span class="" style="">
                  <Button
                    icon="pi pi-copy"
                    class="p-button-link"
                    style="font-size: 12px;margin-bottom: 8px;"
                    v-tooltip.top="tooltipMsg"
                    @click="doCopy(selectedform)"
                  />
           </span>
        </div>
      </template>
    </Toolbar>
    <div class="formbuilder" v-if="!blockedDocument">
      <div class="selectedform">
        <!-- <Button
          v-if="$route.params.formid != null"
          label="Back to List"
          icon="pi pi-arrow-left"
          class="p-button-link p-mr-2"
          @click="backto()"
        />
        <Card style="margin-bottom: 2em">
          <template slot="title" v-if="$route.params.formid != null">
            Form Preview
          </template>
          <template slot="content" class="m-0 p-0">
            <div class="p-grid">
              <div class="p-col-5">
                <span class="m-0 p-0">
                  <label class="formlabel"> <b>Form Name </b> :</label>
                  {{ selectedform.name }}
                </span>
              </div>
              <div class="p-col-3">
                <span :class="'customstatus published '">
                  <label class="formlabel">Form Status :</label>
                  published
                </span>
                <span>
                  <Button
                    icon="pi pi-copy"
                    class="p-button-link"
                    style="font-size: 12px; margin-left: -2px"
                    v-tooltip.top="tooltipMsg"
                    @click="doCopy(selectedform)"
                  />
                </span>
              </div>
            </div>

            <p class="m-0 p-0">
              <label class="formlabel"> <b>Form Description </b> :</label>
              {{ selectedform.description }}
            </p>
          </template>
        </Card> -->
      </div>
      <formio
        class="p-field p-col-12 p-md-12"
        :key="componentKey"
        v-bind:form="selectedform.schema"
        v-bind:options="options"
        v-bind:formLoad="onFormRendered"
        id="formio"
        ref="formioForm"
      ></formio>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { Form } from "vue-formio";
export default {
  name: "publishedFormComponent",
  components: { formio: Form },
  data() {
    return {
      blockedPanel: false,
      blockedDocument: false,
      displayConfirmation: false,
      selectedform: null,
      formid: this.selectedFormId
        ? this.selectedFormId
        : this.$route.params.formid,
      applicationid: this.selectedApplicationid
        ? this.selectedApplicationid
        : this.$route.params.applicationid,
      confirmHeader: null,
      isReviewer: false,
      isPublisher: false,
      isAccepted: false,
      submitted: false,
      remark: null,
      isDraft: false,
      selectedFormId: null,
      selectedApplicationid: null,
      tooltipMsg: "Copy form Path",
      options: {},
      componentKey: 0,
    };
  },
  created() {
    this.loadedForm = _.clone(this.$store.getters["forms/getSelectedForm"]);
    this.selectedFormId = this.loadedForm.id;
    this.selectedApplicationid = this.loadedForm.applicationId;
    this.getSelectedform();
  },
  mounted() {},
  methods: {
    async onFormRendered() {
      // console.log("Form is rendered");
    },
    doCopy: function (data) {
      let that = this;
      that.$root.$emit("doCopy", data);
    },
    getSelectedform() {
      let that = this;
      let form = {};
      form.formId = this.selectedFormId
        ? this.selectedFormId
        : this.$route.params.formid;
      form.applicationId = this.selectedApplicationid
        ? this.selectedApplicationid
        : this.$route.params.applicationid;
      that.blockedDocument = true;
      that.$store
        .dispatch("forms/getPublishedForm", form)
        .then(() => {
          let response = _.clone(that.$store.getters["forms/getPublishedForm"]);
          // console.log(response);
          that.blockedDocument = false;
          that.selectedform = _.clone(response);
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error while fetching the application form",
            detail: error.response.data,
            life: 3000,
          });
        });
    },

    backto() {
      this.$router.push("/forms");
      this.blockedDocument = false;
    },
  },
  props: {},
  watch: {},
};
</script>
<style scoped>
.formbuilderbtns {
  text-align: center;
}
.formbuilder {
  /* max-height: 600px;
  min-height: 600px; */
  height: 550px;
  overflow: hidden scroll;
  padding: 1%;
  background: #ffffff;
}
.active {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
  border: #c8e6c9 !important;
}
@media screen and (max-width: 1366px) and (max-height: 768px){
    /* Crazy CSS overrides here */
  .formbuilder {
  /* max-height: 537px;
  min-height: 537px; */
  height: 420px;
  overflow: hidden scroll;
  padding: 1%;
  background: #ffffff;
}
}
</style>
